module.exports = __webpack_public_path__ + "img/businessman-application-human-digital-business.8a076382.jpg";